<template>
  <div v-show="show">
    <ui-modal v-if="modal" :docSign="true" :close="closeModal">
      <div class="modal-header">
        <h5 class="modal-title">Подписать документ</h5>
        <button class="btn-close" type="button" @click="closeModal"></button>
      </div>
      <div class="modal-body p-0">
        <div
          v-if="loadingPdf"
          :style="{ height: `calc(100vh - ${headerHeight}px - 57px - 5rem)` }"
          class="page-center"
        >
          <div class="page-center-box text-center">
            <ui-loading-page />
          </div>
        </div>

        <div v-else class="row">
          <div class="col">
            <iframe
              :src="pdfUrl"
              type="application/pdf"
              :style="{
                height: `calc(100vh - ${headerHeight}px - 57px - 5rem)`,
              }"
              width="100%"
            ></iframe>
          </div>
          <div
            v-if="!(status >= 1)"
            class="col-auto me-3"
            style="max-width: 400px"
          >
            <div class="px-3 pt-3">
              <div class="row align-items-center">
                <div class="col">Дата документа</div>
                <div class="col-auto text-end fw-bold">
                  {{
                    props.data?.Created
                      ? dateMask(props.data.Created)
                      : dateMask(new Date())
                  }}
                </div>
              </div>
              <div
                class="row align-items-center"
                style="
                  border-top: 1px solid #f5f5f5;
                  margin-top: 1rem;
                  padding-top: 1rem;
                "
              >
                <div class="col">Оригинал документа</div>
                <div class="col-auto text-end">
                  <ui-button
                    @click="downloadBase64FilePdf(base64File, docId)"
                    :loading="loadingPrint"
                    class="btn btn-base btn-small"
                    >Скачать</ui-button
                  >
                </div>
              </div>

              <input
                ref="mchdInput"
                type="file"
                accept=".xml"
                style="display: none"
                @change="onMchdFileChange"
              />

              <div
                v-if="!mchdFileName"
                class="row align-items-center"
                style="
                  border-top: 1px solid #f5f5f5;
                  margin-top: 1rem;
                  padding-top: 1rem;
                "
              >
                <div class="col">Доверенность</div>
                <div class="col-auto text-end">
                  <ui-button
                    @click="openMchdFileDialog"
                    class="btn btn-ghost btn-small"
                    >Прикрепить МЧД</ui-button
                  >
                </div>
              </div>

              <!-- Если файл выбран -->
              <div
                v-else
                style="
                  border-top: 1px solid #f5f5f5;
                  margin-top: 1rem;
                  padding-top: 1rem;
                "
                class="d-flex align-items-center gap-2"
              >
                <ui-button
                  style="min-width: 92px"
                  class="btn btn-ghost btn-small"
                  @click="removeMchdFile"
                >
                  Удалить
                </ui-button>

                <div
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  {{ mchdFileName }}
                </div>
              </div>
            </div>

            <div class="flex-grow-1 page-title">Подпись</div>
            <div class="hr mb-3"></div>

            <div v-if="status == 1">
              <div class="login-alert p-3 text-center">
                <div class="text-primary">Внимание!</div>
                <span
                  >Документ принят! После проверки с вами свяжется
                  менеджер.</span
                >
              </div>
            </div>
            <div v-else>
              <div v-if="error" class="login-alert p-3 text-center mb-3 me-3">
                <div class="text-primary">{{ error.error }}</div>
                <span v-html="error.msg"></span>
              </div>

              <div v-if="itemSign">
                <div v-if="type == 'ru-token' && itemSign">
                  <div class="mb-3 fw-bold">
                    Для подписания анкеты лизингополучателя с помощью ЭЦП на
                    носителе Рутокен необходимо:
                  </div>

                  <ul>
                    <li>
                      Квалифицированная электронная подпись (ЭЦП), выданная ФНС
                      России и записанная на Рутокен
                    </li>
                    <li>
                      Браузер: Яндекс.Браузер, Google Chrome, Firefox или
                      Microsoft Edge
                    </li>
                    <li>
                      Криптографический
                      <a
                        href="https://www.rutoken.ru/products/all/rutoken-plugin/"
                        target="_blank"
                        >плагин Рутокен</a
                      >
                    </li>
                  </ul>

                  <div class="d-flex flex-wrap gap-2">
                    <ui-button
                      @click="signed"
                      :loading="loading"
                      class="btn-base"
                      >Подписать</ui-button
                    >

                    <ui-button
                      @click="close"
                      class="btn-ghost"
                      :disabled="loading"
                      >Выбрать другой тип ЭЦП</ui-button
                    >
                  </div>
                </div>
                <div v-else-if="type == 'crypto-pro' && itemSign">
                  <div class="mb-3 fw-bold">
                    Для подписания анкеты лизингополучателя с помощью ЭЦП на
                    носителе CryptoPro необходимо:
                  </div>

                  <ul>
                    <li>
                      Квалифицированная электронная подпись (ЭЦП), выданная ФНС
                      России и записанная на носитель CryptoPro
                    </li>
                    <li>
                      Браузер: Яндекс.Браузер, Google Chrome, Firefox или
                      Microsoft Edge
                    </li>
                    <li>
                      Криптографический
                      <a
                        href="https://www.cryptopro.ru/products/cades/plugin"
                        target="_blank"
                        >плагин КриптоПро</a
                      >
                    </li>
                  </ul>

                  <div class="d-flex flex-wrap gap-2">
                    <ui-button
                      @click="signed"
                      :loading="loading"
                      class="btn-base"
                      >Подписать</ui-button
                    >

                    <ui-button
                      @click="close"
                      class="btn-ghost"
                      :disabled="loading"
                      >Выбрать другой тип ЭЦП</ui-button
                    >
                  </div>
                </div>
                <div v-else-if="type == 'jakarta' && itemSign">
                  <div class="mb-3 fw-bold">
                    Для подписания анкеты лизингополучателя с помощью ЭЦП на
                    носителе JaCarta необходимо:
                  </div>

                  <ul>
                    <li>
                      Квалифицированная электронная подпись (ЭЦП), выданная ФНС
                      России и записанная на JaCarta
                    </li>
                    <li>
                      Браузер: Яндекс.Браузер, Google Chrome, Firefox или
                      Microsoft Edge
                    </li>
                    <li>
                      <a
                        href="https://www.aladdin-rd.ru/catalog/jcwebclient/"
                        target="_blank"
                        >JC-WebClient</a
                      >
                      необходим для связи USB-устройств c браузером, он
                      позволяет опознавать устройства и работать с ними.
                    </li>
                  </ul>

                  <div class="d-flex flex-wrap gap-2">
                    <ui-button
                      @click="signed"
                      :loading="loading"
                      class="btn-base"
                      >Подписать</ui-button
                    >

                    <ui-button
                      @click="close"
                      class="btn-ghost"
                      :disabled="loading"
                      >Выбрать другой тип ЭЦП</ui-button
                    >
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="mb-3 fw-bold">
                  Пожалуйста, вставьте носитель с ЭЦП в USB-порт вашего
                  компьютера и выберите тип ЭЦП.
                </div>

                <div class="row">
                  <div class="col-12 sign-box">
                    <EcpButton
                      @auth="getCertificatesObject"
                      :loading="loading"
                      :loginType="type"
                    />

                    <Certificates
                      v-if="certificatesObject"
                      :certificatesObject="certificatesObject"
                      @close="() => (certificatesObject = null)"
                      @getCertificat="getCertificat"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="true"
          ref="header"
          style="border-radius: 0 0 5px 5px; border-top: 1px solid #f5f5f5"
        >
          <table class="table">
            <thead>
              <tr>
                <th style="width: 100%">Подписант</th>
                <th class="text-nowrap">Статус</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in props.data?.data?.users" :key="index">
                <td style="width: 100%">
                  {{ item.company }} (ИНН: {{ item.inn }})
                </td>
                <td class="text-nowrap" v-if="item.sign">
                  Подписано - {{ dateMask(item.sign) }}
                </td>
                <td class="text-nowrap" v-else>На подписании</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- <div ref="header" class="p-3">
          <div v-if="status == 1">
            <div class="login-alert p-3 text-center">
              <div class="text-primary">Внимание!</div>
              <span
                >Документ принят! После проверки с вами свяжется менеджер.</span
              >
            </div>
          </div>
          <div v-else>
            <div v-if="error" class="login-alert p-3 text-center mb-3">
              <div class="text-primary">{{ error.error }}</div>
              <span v-html="error.msg"></span>
            </div>

            <div v-if="itemSign">
              <div v-if="type == 'ru-token' && itemSign">
                <div class="mb-3 fw-bold">
                  Для подписания анкеты лизингополучателя с помощью ЭЦП на
                  носителе Рутокен необходимо:
                </div>

                <ul>
                  <li>
                    Квалифицированная электронная подпись (ЭЦП), выданная ФНС
                    России и записанная на Рутокен
                  </li>
                  <li>
                    Браузер: Яндекс.Браузер, Google Chrome, Firefox или
                    Microsoft Edge
                  </li>
                  <li>
                    Криптографический
                    <a
                      href="https://www.rutoken.ru/products/all/rutoken-plugin/"
                      target="_blank"
                      >плагин Рутокен</a
                    >
                  </li>
                </ul>

                <div class="d-flex flex-wrap gap-2">
                  <ui-button @click="signed" :loading="loading" class="btn-base"
                    >Подписать</ui-button
                  >

                  <ui-button
                    @click="close"
                    class="btn-ghost"
                    :disabled="loading"
                    >Выбрать другой тип ЭЦП</ui-button
                  >
                </div>
              </div>
              <div v-else-if="type == 'crypto-pro' && itemSign">
                <div class="mb-3 fw-bold">
                  Для подписания анкеты лизингополучателя с помощью ЭЦП на
                  носителе CryptoPro необходимо:
                </div>

                <ul>
                  <li>
                    Квалифицированная электронная подпись (ЭЦП), выданная ФНС
                    России и записанная на носитель CryptoPro
                  </li>
                  <li>
                    Браузер: Яндекс.Браузер, Google Chrome, Firefox или
                    Microsoft Edge
                  </li>
                  <li>
                    Криптографический
                    <a
                      href="https://www.cryptopro.ru/products/cades/plugin"
                      target="_blank"
                      >плагин КриптоПро</a
                    >
                  </li>
                </ul>

                <div class="d-flex flex-wrap gap-2">
                  <ui-button @click="signed" :loading="loading" class="btn-base"
                    >Подписать</ui-button
                  >

                  <ui-button
                    @click="close"
                    class="btn-ghost"
                    :disabled="loading"
                    >Выбрать другой тип ЭЦП</ui-button
                  >
                </div>
              </div>
              <div v-else-if="type == 'jakarta' && itemSign">
                <div class="mb-3 fw-bold">
                  Для подписания анкеты лизингополучателя с помощью ЭЦП на
                  носителе JaCarta необходимо:
                </div>

                <ul>
                  <li>
                    Квалифицированная электронная подпись (ЭЦП), выданная ФНС
                    России и записанная на JaCarta
                  </li>
                  <li>
                    Браузер: Яндекс.Браузер, Google Chrome, Firefox или
                    Microsoft Edge
                  </li>
                  <li>
                    <a
                      href="https://www.aladdin-rd.ru/catalog/jcwebclient/"
                      target="_blank"
                      >JC-WebClient</a
                    >
                    необходим для связи USB-устройств c браузером, он позволяет
                    опознавать устройства и работать с ними.
                  </li>
                </ul>

                <div class="d-flex flex-wrap gap-2">
                  <ui-button @click="signed" :loading="loading" class="btn-base"
                    >Подписать</ui-button
                  >

                  <ui-button
                    @click="close"
                    class="btn-ghost"
                    :disabled="loading"
                    >Выбрать другой тип ЭЦП</ui-button
                  >
                </div>
              </div>
            </div>
            <div v-else>
              <div class="mb-3 fw-bold">
                Пожалуйста, вставьте носитель с ЭЦП в USB-порт вашего компьютера
                и выберите тип ЭЦП.
              </div>

              <div class="row">
                <div class="col-12 sign-box">
                  <EcpButton
                    @auth="getCertificatesObject"
                    :loading="loading"
                    :loginType="type"
                  />

                  <Certificates
                    v-if="certificatesObject"
                    :certificatesObject="certificatesObject"
                    @close="() => (certificatesObject = null)"
                    @getCertificat="getCertificat"
                  />
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <!-- <div class="modal-footer"></div> -->
    </ui-modal>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, nextTick } from "vue";

import { useStore } from "vuex";
const store = useStore();

import CryptoECP from "../../../lib/crypto";
import EcpButton from "../../../component/ecp/Button.vue";
import Certificates from "../../../component/ecp/Certificates.vue";

// import PdfViewer from "../PdfViewer/index.vue";

import { postApi, dateMask } from "../../../run";

const header = ref(null);
const headerHeight = ref(0);
const users = ref([{}, {}]);

// функция обновления высоты
const updateHeight = () => {
  if (header.value) {
    headerHeight.value = header.value.offsetHeight;
  }
};

// также можно слушать resize окна
window.addEventListener("resize", updateHeight);

// defineEmits для отправки событий наружу
const emit = defineEmits(["modalClose"]);

const closeModal = () => emit("modalClose");

const props = defineProps({
  modal: {
    type: Boolean,
    default: false,
  },
  status: {
    type: [Number, String],
  },
  docId: {
    type: [Number, String],
  },
  data: {
    type: Object,
  },
  setStatus: { type: Function },
});

const status = ref(0);

watch(
  () => props.status,
  (newVal) => {
    status.value = newVal;
  },
  { immediate: true } // если надо сразу установить значение при загрузке
);

const docId = ref(null);

watch(
  () => props.docId,
  (newVal) => {
    docId.value = newVal;
    if (newVal) {
      getFile(newVal);
    }
  },
  { immediate: true } // если надо сразу установить значение при загрузке
);

const loadingPdf = ref(false);

const getFile = (id) => {
  loadingPdf.value = true;
  postApi("/leasing/getFileApi", {
    id: id,
  })
    .then((res) => {
      if (res.base64File) {
        base64File.value = res.base64File;
      } else {
        closeModal();
      }
    })
    .finally(() => {
      loadingPdf.value = false;
    });
};

const pdfUrl = computed(() => {
  const file = base64File.value;

  if (!file) return null;

  if (!file.startsWith("data:application/pdf;base64,")) {
    return `data:application/pdf;base64,${file}`;
  }

  return file;
});

const crypto = ref(null);
const error = ref(null);
const type = ref(null);
const loading = ref(false);

const base64File = ref(null);
const certificatesObject = ref(null);
const itemSign = ref(null);
const fileSign = ref(null);

const show = ref(true);

const getCertificatesObject = (ecpType) => {
  if (!loading.value) {
    show.value = true;
    error.value = null;
    loading.value = true;
    type.value = ecpType;
    const ecp =
      ecpType === "ru-token"
        ? CryptoECP.ECP_RU_TOKEN
        : ecpType === "crypto-pro"
        ? CryptoECP.ECP_CRYPTO_PRO
        : ecpType === "jakarta"
        ? CryptoECP.ECP_JAKARTA
        : null;

    crypto.value = new CryptoECP(ecp);

    crypto.value.init(
      (ecpInfo) => {
        // show.value = false;
        certificatesObject.value = ecpInfo;
        loading.value = false;
      },
      (initException) => {
        closeModal();
        store.commit("main/setAuthException", initException);
        loading.value = false;
        type.value = null;
      }
    );
  }
};

const signFile = async () => {
  loading.value = true;

  await props.getFile().then((d) => {
    if (d.error) {
      loading.value = false;
      error.value = d;
    } else {
      loading.value = false;
      base64File.value = d;
    }
  });
};

// const signed = () => {
//   loading.value = true;
//   crypto.value.signData(
//     itemSign.value.id,
//     base64File.value,
//     (fileSignSuccess) => {
//       fileSign.value = fileSignSuccess;
//       crypto.value.verifySign(
//         base64File.value,
//         fileSign.value,
//         () => {
//           postApi("/signedDoc", {
//             docId: docId.value,
//             originalFile: base64File.value,
//             signedFile: fileSign.value,
//             certificate: JSON.stringify(itemSign.value),
//           }).then((res) => {
//             if (res.status == 1) {
//               props.setStatus(docId.value, res.status);
//               closeModal();
//               base64File.value = false;
//             } else if (res.error) {
//               error.value = res;
//               base64File.value = false;
//             }
//             loading.value = false;
//           });
//         },
//         (e) => {
//           store.commit("main/setAuthException", e);
//           loading.value = false;
//           base64File.value = false;
//         }
//       );
//     },
//     (e) => {
//       store.commit("main/setAuthException", e);
//       loading.value = false;
//       base64File.value = false;
//     }
//   );
// };

const signed = () => {
  loading.value = true;
  crypto.value.signData(
    itemSign.value.id,
    base64File.value,
    (fileSignSuccess) => {
      fileSign.value = fileSignSuccess;
      crypto.value.verifySign(
        base64File.value,
        fileSign.value,
        () => {
          postApi("/signed", {
            UID: props.data.RID,
            originalFile: base64File.value,
            signedFile: fileSign.value,
            certificate: JSON.stringify(itemSign.value),
            mchd: mchdBase64.value,
          }).then((res) => {
            if (res.status == 1) {
              props.setStatus(docId.value, res.status, res.inn);
              closeModal();
              base64File.value = false;
            } else if (res.error) {
              error.value = res;
              base64File.value = false;
            }
            loading.value = false;
          });
        },
        (e) => {
          store.commit("main/setAuthException", e);
          loading.value = false;
          base64File.value = false;
        }
      );
    },
    (e) => {
      store.commit("main/setAuthException", e);
      loading.value = false;
      base64File.value = false;
    }
  );
};

// const getCertificat = (item) => {
//   certificatesObject.value = null;

//   show.value = true;
//   error.value = null;
//   loading.value = true;
//   //   postApi("/fns", {
//   //     certificate: JSON.stringify(item),
//   //     UID: props.uid,
//   //   }).then((res) => {
//   // if (res.error) {
//   //   error.value = res;
//   //   loading.value = false;
//   // } else {
//   crypto.value.getCertificate(
//     item.id,
//     (certificate) => {
//       console.log(certificate);

//       itemSign.value = item;
//       crypto.value.readCertificate(item.id, (readCertificate) => {
//         loading.value = false;
//       });
//     },
//     (e) => {
//       itemSign.value = null;
//       store.commit("main/setAuthException", e);
//       loading.value = false;
//     }
//   );
//   // }
//   //   });
// };

const getCertificat = (item) => {
  certificatesObject.value = null;
  error.value = null;
  loading.value = true;
  postApi("/fns", {
    mchd: mchdBase64.value,
    certificate: JSON.stringify(item),
    UID: props.data.RID,
    checkMchd: props.mchd,
  }).then((res) => {
    if (res.error) {
      error.value = res;
      loading.value = false;
    } else {
      crypto.value.getCertificate(
        item.id,
        (certificate) => {
          console.log(certificate);

          itemSign.value = item;
          crypto.value.readCertificate(item.id, (readCertificate) => {
            loading.value = false;
          });
        },
        (e) => {
          itemSign.value = null;
          store.commit("main/setAuthException", e);
          loading.value = false;
        }
      );
    }
  });
};

const loadingPrint = ref(false);

const downloadBase64FilePdf = async (base64, name) => {
  // Создаем Blob из base64
  loadingPrint.value = true;
  const byteCharacters = atob(base64);
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "application/pdf" });

  // Создаем ссылку и симулируем клик
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = name + ".pdf"; // Название скачиваемого файла
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href); // Освобождаем память
  setTimeout(() => (loadingPrint.value = false), 300);
};

const mchdInput = ref(null);
const mchdFileName = ref(null);
const mchdBase64 = ref(null);

const openMchdFileDialog = () => {
  mchdInput.value?.click();
};

const onMchdFileChange = (event) => {
  const file = event.target.files[0];

  if (!file) return;

  if (!file.name.toLowerCase().endsWith(".xml")) {
    alert("Можно выбрать только XML файл");
    return;
  }

  mchdFileName.value = file.name;

  const reader = new FileReader();

  reader.onload = () => {
    const result = reader.result;

    // Убираем data:...base64,
    mchdBase64.value = result.split(",")[1];
  };

  reader.readAsDataURL(file);
};

const removeMchdFile = () => {
  mchdFileName.value = null;
  mchdBase64.value = null;

  if (mchdInput.value) {
    mchdInput.value.value = "";
  }
};

// watch на modal или show, чтобы дождаться рендера
watch(
  [
    () => props.modal,
    () => props.status,
    () => itemSign.value,
    () => type.value,
  ],
  async ([modalVal, statusVal, itemSignVal, typeVal]) => {
    if (modalVal) {
      await nextTick();
      updateHeight();
    }
  }
);

watch([() => props.modal], async ([modalVal]) => {
  if (modalVal) {
    base64File.value = null;
  }
});
const close = () => {
  error.value = null;
  type.value = null;
  itemSign.value = null;
};
</script>